import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Bar } from "react-chartjs-2";
import { getDataAction } from "../../config/redux/action";
import { KI_DATA, MONTHS } from "../../constants";
import numeral from "numeral";

export default () => {
  let dataChart = {};
  const dispatch = useDispatch();
  const { kuartal, year, perusahaan, type, data } = useSelector(
    (state) => state.filterKinerja
  );

  const initData = async () => {
    const path = `chart/tren-kinerja?year=${year}&kuartal=${kuartal}&perusahaanId=${perusahaan}&type=${type}`;
    const actionType = KI_DATA; // result

    dispatch(getDataAction({ path, type: actionType }));
  };

  React.useEffect(() => {
    initData();
  }, [kuartal, year, perusahaan, type]);

  if (data) {
    const value = data.map((a) => a.value);
    const rkap = data.map((a) => a.rkap);
    const valueBefore = data.map((a) => a.preValue);
    value.push(0);
    rkap.push(0);
    valueBefore.push(0);
    const dataset = [

      {
        label: year - 1,
        data: valueBefore,
        fill: true,
        backgroundColor: "#1F78B4",
        pointRadius: 8,
        pointBackgroundColor: "#fff",
      },
      {
        label: `RKAP ${year}`,
        data: rkap,
        fill: true,
        backgroundColor: "#A6CEE3",
        pointRadius: 8,
        pointBackgroundColor: "#fff",
      },
      {
        label: year,
        fill: true,
        data: value,
        backgroundColor: "#6A3D9A",
        borderColor: "rgba(0,199,239, 0.5)",
      },
    ];
    dataChart = {
      labels: data.map((d) => MONTHS[d.month - 1]),
      datasets: dataset,
    };
  }

  const options = {
    responsive: true,
    legend: {
      display: true,
      position: "bottom",
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          const n = tooltipItem.datasetIndex;
          return "Tahun " + data.datasets[n].label;
        },
        footer: (tooltipItems, data) => {
          const tooltip = tooltipItems[0];
          return "Rp " + numeral(tooltip.value).format(0, 0);
        },
      },
    },
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
          },
          ticks: {
            display: true,
            minRotation: 0,
            callback: (value, index, values) => {
              return numeral(value).format(0, 0);
            },
          },
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          scaleLabel: {
            display: true,
          },
          ticks: {
            display: true,
            minRotation: 0,
          },
        },
      ],
    },
  };

  return (
    <div>
      <Bar
        redraw={true}
        data={dataChart}
        width={3}
        height={1}
        options={options}
      />
    </div>
  );
};
